import * as React from 'react';
import { Konkurrence } from '../../models/Konkurrence';
import TilmeldHoldPresenter from './TilmeldHoldPresenter';
import { Spinner } from '../../uiComponents/Spinner';
import { Bruger } from '../../models/Bruger';
import { Tilmelding } from '../../models/Tilmelding';
import { Hold } from '../../models/Hold';
import { ValidationResult } from '../../infrastructure/ValidationResult';
import TilmeldingBekraeft from './TilmeldingBekraeftelse';
import { Institution } from '../../models/Institution';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { StepsWrapper, Step } from '../../uiComponents/Steps';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { RouteComponentProps } from 'react-router';
import { Laerer } from '../../models/Laerer';
import { getHoldListFromCache } from '../../infrastructure/HoldListCache';
import { Guid } from '../../infrastructure/Guid';
import { UniloginBruger } from '../../models/UniloginBruger';

export interface TilmeldHoldContainerProps extends RouteComponentProps<any> {
    konkurrenceId: string;
    venteliste: boolean;
}

export interface TilmeldingHoldContainerState {
    konkurrence?: Konkurrence;
    tilmelding: Tilmelding;
    bruger: Bruger;
    holdListe?: Hold[];
    isSaved: boolean;
    validationResult: ValidationResult;
    institution: Institution;
    isSubmitting: boolean;
    uniloginBruger: UniloginBruger;
    uniloginDataFetched: boolean;
    isSubmittingUnilogin: boolean;
}

class TilmeldHoldContainer extends React.Component<TilmeldHoldContainerProps, TilmeldingHoldContainerState> {
    constructor(props: TilmeldHoldContainerProps) {
        super(props);

        const tilmelding = new Tilmelding();
        tilmelding.paaVenteliste = props.venteliste;
        tilmelding.konkurrenceId = props.konkurrenceId;
        tilmelding.inviteredeLaerere = [];
        tilmelding.tilmeldteLaerere = [];
        this.state = {
            konkurrence: undefined, holdListe: undefined, bruger: getLoggedInBruger(),
            isSaved: false, tilmelding: tilmelding, validationResult: new ValidationResult(), institution: getLoggedInBruger().institutioner[0],
            isSubmitting: false,
            uniloginBruger: new UniloginBruger(),
            uniloginDataFetched: false,
            isSubmittingUnilogin: false
        };

        this.onTilmeldingSave = this.onTilmeldingSave.bind(this);
        this.onTilmeldingChanged = this.onTilmeldingChanged.bind(this);
        this.onInviteringAdded = this.onInviteringAdded.bind(this);
        this.onLaererRemoved = this.onLaererRemoved.bind(this);
        this.onUniloginBrugerChanged = this.onUniloginBrugerChanged.bind(this);
        this.onGetDataForUniLogin = this.onGetDataForUniLogin.bind(this);
    }

    componentDidMount() {
        const apiCaller = createApiCaller();
        let konkurrencePromis = apiCaller.getKonkurrence(this.props.konkurrenceId);
        let self = this;
        konkurrencePromis.then(json => self.setState({ konkurrence: json }));
        self.setState({ holdListe: getHoldListFromCache() });
    }

    onTilmeldingSave() {
        this.setState({ isSubmitting: true });
        var self = this;
        createApiCaller().createTilmelding(this.state.tilmelding).then((validationResult: ValidationResult) => {
            self.setState(
                {
                    isSaved: validationResult.isValid ? true : false,
                    validationResult: validationResult,
                    isSubmitting: false
                });
        }
        );
    }

    onInviteringAdded() {
        const newState = this.state;
        const laerer = new Laerer();
        laerer.uiId = Guid.newGuid();
        newState.tilmelding.inviteredeLaerere.push(laerer);
        this.setState(newState);
    }

    onTilmeldingChanged(fieldName: string, value: any) {
        if (fieldName === 'institutionsnummer') {
            const valgtInst = this.state.bruger.institutioner.filter(i => i.institutionsnummer === value)[0];
            this.setState({ institution: valgtInst });
        } else if (fieldName === 'gruppeId') {
            if (this.state.holdListe != null) {
                let hold = this.state.holdListe.filter(h => h.gruppeId === value)[0];
                let changedTilmelding = this.state.tilmelding;
                changedTilmelding.hold = hold;
                this.setState({ tilmelding: changedTilmelding });
            }
        } else {
            let changedTilmelding = this.state.tilmelding;
            changedTilmelding[fieldName] = value;
            this.setState({ tilmelding: changedTilmelding });
        }
    }

    onLaererRemoved() {
        // Do nothing
    }

    onUniloginBrugerChanged(fieldname: string, value: string) {
        let changedUniloginBruger = this.state.uniloginBruger;
        changedUniloginBruger[fieldname] = value;
        this.setState({ uniloginBruger: changedUniloginBruger });
    }

    onGetDataForUniLogin() {
        var uniloginBrugerState = this.state.uniloginBruger;
        if (uniloginBrugerState.brugernavn !== undefined && uniloginBrugerState.navn !== undefined && uniloginBrugerState.email !== undefined) {
            this.setState({ uniloginDataFetched: false, isSubmittingUnilogin: true });

            const apiCaller = createApiCaller();

            apiCaller.getOrCreateBruger(this.state.uniloginBruger).then((response: any) => {
                let bruger: Bruger = response.data;
                let tilmelding = this.state.tilmelding;
                tilmelding.brugerNavn = bruger.brugernavn;

                this.setState({ bruger: bruger, tilmelding: tilmelding });

                apiCaller.getHoldForBruger(this.state.uniloginBruger.brugernavn).then((hold: Hold[]) => {
                    this.setState({ holdListe: hold, uniloginDataFetched: true, isSubmittingUnilogin: false });
                });
            });
        }
    }

    render() {
        if (this.state.konkurrence == null || this.state.holdListe == null) {
            return <Spinner />;
        } else {
            if (this.state.isSaved && this.state.tilmelding != null) {
                return (
                    <TilmeldingBekraeft
                        konkurrence={this.state.konkurrence}
                        tilmeldtInstitution={this.state.institution.navn}
                        laererNavn={this.state.bruger.navn}
                        tilmelding={this.state.tilmelding}
                        opgavepakkeTitel={this.state.konkurrence.opgavepakker.filter(o => o.id === this.state.tilmelding.opgavepakkeId)[0].titel}
                        venteliste={this.props.venteliste}
                    />
                );

            } else {
                const holdListe = this.state.holdListe.filter(h => h.institution.institutionsnummer === this.state.institution.institutionsnummer);
                return (

                    <ContentWrapper>
                        <StepsWrapper>
                            <Step href='/tilmelding/login' label='1' state='done'>
                                Login
                            </Step>
                            <Step href='/tilmelding/vaelg-konkurrence' label='2' state='done'>
                                Vælg konkurrence
                            </Step>
                            <Step href='#' label='3' state='active'>
                                Tilmeld hold
                            </Step>
                            <Step href='#' label='4' state='ahead'>
                                Bekræft
                            </Step>
                        </StepsWrapper>
                        <TilmeldHoldPresenter
                            konkurrence={this.state.konkurrence}
                            primaerLaerer={this.state.bruger}
                            tilmelding={this.state.tilmelding}
                            holdListe={holdListe}
                            validationResult={this.state.validationResult}
                            onTilmeldingSave={this.onTilmeldingSave}
                            onTilmeldingChanged={this.onTilmeldingChanged}
                            opretRediger='opret'
                            history={this.props.history}
                            location={this.props.location}
                            match={this.props.match}
                            isSubmitting={this.state.isSubmitting}
                            onInvitationAdded={this.onInviteringAdded}
                            onLaererRemoved={this.onLaererRemoved}
                            valgtInstitution={this.state.institution}
                            venteliste={this.props.venteliste}
                            onUniloginBrugerChanged={this.onUniloginBrugerChanged}
                            onGetDataForUnilogin={this.onGetDataForUniLogin}
                            uniloginDataFetched={this.state.uniloginDataFetched}
                            uniloginBruger={this.state.uniloginBruger}
                            isSubmittingUnilogin={this.state.isSubmittingUnilogin}
                        />
                    </ContentWrapper>
                );
            }
        }
    }
}

export default TilmeldHoldContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/tilmelding/TilmeldHoldContainer.tsx